import {
  SchemaInstance,
  defineSchema,
} from "@redotech/redo-flows-core-schema-common/type-system/schema";

/**
 * Schema for Withdrawal flow triggers. Withdrawal flows are global (one set of
 * docs shared by every team, not team-scoped) and are not editable in the
 * merchant app, so — unlike Compensation/Restocking/Return Processing — this
 * schema needs no condition-builder or insert-variable fields.
 *
 * At runtime the only value read off the schema instance is `returnId`: the
 * `return_flow_condition` and `compensation_step` handlers use it to reload the
 * Return, then derive everything else from the Return/Order directly (see
 * `build-return-flow-condition-params.ts`). Every other field on the
 * Compensation/Restocking schemas is edit-time scaffolding that is dead for a
 * no-editor flow, so it is intentionally omitted here. If a Withdrawal editor
 * is ever built, add fields back then.
 */
export const withdrawalFlowSchema = defineSchema({
  fields: {
    returnId: {
      dataType: "Text",
      documentation: "The unique identifier for the return in Redo",
      hideFromConditionStep: true,
      hideFromInsertionModal: true,
    },
  },
});

export const exampleWithdrawalFlowSchemaInstance: SchemaInstance<
  typeof withdrawalFlowSchema
> = { returnId: "65b81f41da22f4000718b34e" };
